import axios from '@axios'

const route = 'financial/cash_flow'

export default {
  namespaced: true,
  state: {
    search: '',
    date_start: '',
    date_end: '',
    typeReport: 'diario',
    filters: {},

  },
  getters: {
    getSearch: state => state.search,
    getDateStart: state => state.date_start,
    getDateEnd: state => state.date_end,
    getFilters: state => state.filters,
    getTypeReport: state => state.typeReport,
  },
  mutations: {
    setSearch(state, search) {
      state.search = search
    },
    setDateStart(state, date_start) {
      state.date_start = date_start
    },
    setDateEnd(state, date_end) {
      state.date_end = date_end
    },
    setFilters(state, filters) {
      state.filters = filters
    },
    setTypeReport(state, typeReport) {
      state.typeReport = typeReport
    },
  },
  actions: {
    // carrega o relatorio de fluxo de caixa
    loadReport(context, data) {
      return axios.post(`${route}/report`, data)
    },

    // //carrega os dados para o grafico de fluxo de caixa
    // chartCashflow(context, data) {
    //   return axios.post(`${route}/chart`, data)
    // },

    // donwload excel
    exportExcelDiary(context, params) {
      return axios.post(`${route}/export_excel`, params, { responseType: 'blob' })
    },

    // donwload pdf
    exportPdfDiary(context, params) {
      return axios.post(`${route}/export_pdf`, params, { responseType: 'blob' })
    },

    exportExcelExtract(context, params) {
      return axios.post(`${route}/export_excel/extract`, params, { responseType: 'blob' })
    },
    exportExcelCashFlowDetails(context, params) {
      return axios.post(`${route}/export_excel/details`, params, { responseType: 'blob' })
    },

    exportPdfExtract(context, params) {
      return axios.post(`${route}/export_pdf/extract`, params, { responseType: 'blob' })
    },

  },
}
